<template>
  <Background :bgColor="data.backgroundColor">
    <GridSection :gridOptions="gridOptions" :body="data.body">
      <template v-slot:title v-if="data.title">{{ data.title }}</template>

      <GridItem
        class="Item"
        v-for="(card, index) in data.cards"
        :key="index"
        :class="{ 'self-start': cardType === 'ImageTextCard' }">
        <component
          :is="cardType"
          :data="card"
          :stepNumber="index + 1"
          :showBorder="index % 2 !== 0"></component>
      </GridItem>
    </GridSection>
  </Background>
</template>

<script>
import Background from "../Atoms/Background.vue";
import Container from "../Atoms/Container.vue";
import BoardMemberCard from "../Modules/Cards/BoardMemberCard.vue";
import CtaCard from "../Modules/Cards/CtaCard.vue";
import EventCard from "../Modules/Cards/EventCard.vue";
import ImageDownloadCard from "../Modules/Cards/ImageDownloadCard.vue";
import ImageTextCard from "../Modules/Cards/ImageTextCard.vue";
import InlineIconCard from "../Modules/Cards/InlineIconCard.vue";
import LargeCtaCard from "../Modules/Cards/LargeCtaCard.vue";
import ListCard from "../Modules/Cards/ListCard.vue";
import TextCard from "../Modules/Cards/TextCard.vue";
import StepCard from "../Modules/Cards/StepCard.vue";
import TextLinkCard from "../Modules/Cards/TextLinkCard.vue";
import GridItem from "../Atoms/Grid/GridItem.vue";
import GridSection from "../Modules/GridSection.vue";
import WebinarVideoCard from "../Modules/Cards/WebinarVideoCard.vue";
import VideoPlayerCard from "../Modules/Cards/VideoPlayerCard.vue";

import { toPascalCase } from "../../compostables/useHelpers";

export default {
  components: {
    Background,
    Container,
    GridItem,
    GridSection,
    BoardMemberCard,
    CtaCard,
    EventCard,
    ImageDownloadCard,
    ImageTextCard,
    InlineIconCard,
    LargeCtaCard,
    ListCard,
    TextCard,
    StepCard,
    TextLinkCard,
    WebinarVideoCard,
    VideoPlayerCard,
  },

  props: {
    data: {
      type: Object,
      required: false,
    },
  },

  setup(props, { slots }) {
    let gridOptions, cardType;

    //Find the number of columns for the grid
    gridOptions = {
      numCols: props.data.numberOfColumns
        ? parseInt(props.data.numberOfColumns)
        : props.data.cards.length,
    };

    // Add vertical border
    if (
      props.data.cards[0].cardLayout.toLowerCase() === "text card" ||
      props.data.cards[0].cardLayout.toLowerCase() === "list card"
    ) {
      gridOptions = {
        ...{
          showBorder: true,
        },
        ...gridOptions,
      };
    }
    cardType = toPascalCase(props.data.cards[0].cardLayout);

    return {
      cardType,
      gridOptions,
    };
  },
};
</script>

<style></style>
